import { getControlItem, togglePlayPause } from '../utils/helpers'
import { BUTTON_ICON_CLASS, CONTROL_CLASS } from '../utils/videoplayer-constants'
import { Controls } from './controls'

export class PlayPause extends Controls {
  constructor(element: HTMLElement, videoPlayer: HTMLVideoElement, wrapperElement: HTMLDivElement) {
    super(element, videoPlayer, wrapperElement)
    this.renderPlayAndPauseButton()
  }

  private renderPlayAndPauseButton() {
    this.controlBarSectionElement.appendChild(
      getControlItem({
        parent: {
          element: 'button',
          classes: [CONTROL_CLASS, 'cmp-video-wrapper__controls--play-pause'],
        },
        children: [
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--play'] },
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--pause'] },
          { element: 'span', classes: [BUTTON_ICON_CLASS, 'cmp-button__icon--reset'] },
        ],
        eventListeners: ['click'],
        callback: e => {
          e.stopPropagation()
          togglePlayPause(this.videoPlayer, this.wrapperElement)
        },
      }),
    )
  }
}
